var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineBlend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.47 17.02a.75.75 0 0 1 0-1.12 5.2 5.2 0 0 0 1.75-3.9 5.2 5.2 0 0 0-1.75-3.9.75.75 0 0 1 0-1.12 6.683 6.683 0 0 1 4.5-1.73c3.72 0 6.75 3.03 6.75 6.75s-3.02 6.75-6.75 6.75c-1.67 0-3.27-.62-4.5-1.73zm4.51.23c2.89 0 5.25-2.36 5.25-5.25s-2.36-5.25-5.25-5.25c-1.03 0-2.03.3-2.88.86a6.73 6.73 0 0 1 0 8.78c.85.56 1.84.86 2.88.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.22 12c0-3.72 3.03-6.75 6.75-6.75 1.67 0 3.27.62 4.5 1.73A6.72 6.72 0 0 1 14.72 12a6.7 6.7 0 0 1-2.25 5.02 6.713 6.713 0 0 1-4.5 1.73c-3.72 0-6.75-3.03-6.75-6.75zm1.5 0c0 2.89 2.36 5.25 5.25 5.25 1.3 0 2.54-.48 3.5-1.35a5.196 5.196 0 0 0 1.75-3.9c0-1.49-.64-2.92-1.75-3.9-.96-.87-2.2-1.35-3.5-1.35-2.89 0-5.25 2.36-5.25 5.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBlend);
export default __webpack_public_path__ + "static/media/vuesax-outline-blend.9692db33fc7a9bf06a4d28a612307045.svg";
export { ForwardRef as ReactComponent };